import React from 'react';
import './MainLayout.css';
import Sidebar from './components/sidebar/Sidebar';
import { Outlet } from 'react-router-dom';

const MainLayout = () => {
    return (
        <React.Fragment>
            <Sidebar />
            <section className='home-section'>
                <div id='mt-router-outlet-main'>
                    <Outlet />
                </div>
            </section>
        </React.Fragment>
    )
}

export default MainLayout
